<p8-layout-settings-page>
  <p8-layout-settings-header [iconRacine]="'edit'"
                             [titlePath]="['Edition du formulaire']"></p8-layout-settings-header>
  <app-form-builder *ngIf="formEdit"
                    (getForm)="getForm($event)"
                    [formModel]="formEdit"></app-form-builder>
  <p8-layout-settings-footer [flexLayoutAlign]="'end'">
    <div>
      <mat-progress-bar [mode]="'indeterminate'" *ngIf="onSaving"></mat-progress-bar>
      <app-form-actions [isDisabled]="onSaving"
                        (submitForm)="onSubmitForm()"
                        (onPreview)="previewForm($event)"></app-form-actions>
    </div>
  </p8-layout-settings-footer>
</p8-layout-settings-page>
<div></div>
